// extracted by css-extract-rspack-plugin
export default {"cls1":"PodcastLibraryCarouselAd-cls1_U40","cls2":"PodcastLibraryCarouselAd-cls2_lUj PodcastLibraryCarouselAd-cls1_U40"};